import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {RemoteGetHealthSpecialtyAuthorization} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';

import {GetHealthSpecialtyAuthorization} from 'domain/usecases';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeGetHealthSpecialtyAuthorization = (): GetHealthSpecialtyAuthorization =>
	new RemoteGetHealthSpecialtyAuthorization(
		makeBFFApiUrl(BookingFlowEndPoints.healthSpecialtyAuthorization),
		makeAuthorizeHttpClientDecorator(),
	);
